export default "__VITE_ASSET__DlCdLL2H__"